import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaXTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa6';
import './footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-brand">
            <h3>MOJ</h3>
            <p>Pakistan's premier inter-city ride-sharing service. Connecting cities, connecting people.</p>
            <div className="social-links">
              <a href="https://www.facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook">
                <FaFacebookF />
              </a>
              <a href="https://www.x.com" target="_blank" rel="noreferrer" aria-label="X">
                <FaXTwitter />
              </a>
              <a href="https://www.instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram">
                <FaInstagram />
              </a>
              <a href="https://www.linkedin.com" target="_blank" rel="noreferrer" aria-label="LinkedIn">
                <FaLinkedinIn />
              </a>
            </div>
          </div>

          <div className="footer-links">
            <h4>Company</h4>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/corporate">Corporate</Link></li>
              <li><Link to="/cities">Our Cities</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-links">
            <h4>Legal</h4>
            <ul>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/data-deletion">Data Deletion</Link></li>
              <li><Link to="/">Terms of Service</Link></li>
              <li><Link to="/">Cookie Policy</Link></li>
            </ul>
          </div>

          <div className="footer-contact">
            <h4>Contact</h4>
            <p>Email: info@mojexpress.com</p>
            <p>Financials: accounts@mojexpress.com</p>
            <p>Phone: +923217946427</p>
            <p>Islamabad, Pakistan (Open 24/7)</p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2024 MOJ Rides. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
